/* eslint-disable @typescript-eslint/no-explicit-any */
import { notification } from 'antd';
import * as FileSaver from 'file-saver';
// eslint-disable-next-line
// const moment = require('moment');
import moment, { Moment } from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { DATE_FORMATS, formateDate } from './date';

export const getSumFromArrayByKey = (array, key): number => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _array: any = [];

  array?.forEach((o) => {
    if (o[key]) {
      _array.push(o[key]);
    }
  });

  if (_array?.length) {
    return _array?.reduce((a, c) => {
      return Number(a) + Number(c);
    });
  } else {
    return 0;
  }
};

export const isDateIsWeekend = (date: string) => {
  let isWeekend = false;
  const day = moment(date).day();

  if (day === 5 || day === 6) {
    isWeekend = true;
  }
  return isWeekend;
};

/**
 *  Accepts the array and key
 * @param array
 * @param key
 *
 */
export const groupDataByKey = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

export function disabledDate(current, type: 'past' | 'future') {
  if (type === 'future') {
    return current && current >= moment().add(1, 'd').startOf('day');
  } else {
    return current && current <= moment().add(1, 'd').startOf('day');
  }
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function getNumberValue(value) {
  if (typeof value === 'string') {
    return value;
  } else {
    return Number(value).toFixed(2);
  }
}

export function getRoundNumber(value) {
  if (typeof value === 'string') {
    return value;
  } else {
    return Math.floor(value);
  }
}

export function extensionType(uri?: string) {
  if (uri) {
    const parts = uri.split('.');
    const extension = parts[parts.length - 1];
    return extension;
  } else {
    return uri;
  }
}

export const getAssetUrl = (url?: string) => {
  if (url) {
    return `${process.env.NX_ASSETS_URL}/${url}`;
  } else {
    return url;
  }
};

export const getFileName = (url?: string) => {
  if (url?.length) {
    const parts = url.split('_');
    return parts[parts.length - 1];
  } else {
    return url;
  }
};

export const createMarketInfoList = (marketInfo) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const listItem: any[] = [];

  if (marketInfo.YCP) {
    listItem.push({
      value: getNumberValue(marketInfo.YCP),
      key: 'ycp',
    });
  }
  if (marketInfo.MKISTAT_PUB_LAST_TRADED_PRICE) {
    listItem.push({
      value: getNumberValue(marketInfo.MKISTAT_PUB_LAST_TRADED_PRICE),
      key: 'ltp',
    });
  }

  if (marketInfo.YCP || marketInfo.MKISTAT_PUB_LAST_TRADED_PRICE) {
    const ycp_ltp = marketInfo.YCP - marketInfo.MKISTAT_PUB_LAST_TRADED_PRICE;
    listItem.push({
      key: 'change',
      value: `${Number(ycp_ltp).toFixed(2)}(${Number(ycp_ltp / marketInfo.MKISTAT_PUB_LAST_TRADED_PRICE).toFixed(2)})%`,
    });
  }
  if (marketInfo.MKISTAT_TOTAL_VALUE) {
    listItem.push({
      value: `${getNumberValue(marketInfo.MKISTAT_TOTAL_VALUE)} mn`,
      key: 'dayValue',
    });
  }

  if (marketInfo.MKISTAT_TOTAL_TRADES) {
    listItem.push({
      value: Number(marketInfo.MKISTAT_TOTAL_TRADES),
      key: 'totalTrade',
    });
  }

  if (marketInfo.MKISTAT_TOTAL_VOLUME) {
    listItem.push({
      value: Number(marketInfo.MKISTAT_TOTAL_VOLUME),
      key: 'volume',
    });
  }
  if (marketInfo.auditedPeRatioUsingBasicEps) {
    listItem.push({
      value: getNumberValue(marketInfo.auditedPeRatioUsingBasicEps),
      key: 'peRatio',
    });
  }
  if (marketInfo.fiftyTwoWeeksMovingRange) {
    listItem.push({
      value: getNumberValue(marketInfo.fiftyTwoWeeksMovingRange),
      key: '52weeksMoving',
    });
  }
  if (marketInfo.open) {
    listItem.push({
      value: getNumberValue(marketInfo.open),
      key: 'openPrice',
    });
  }
  if (marketInfo.dayRange) {
    listItem.push({
      value: getNumberValue(marketInfo.dayRange),
      key: 'dayRange',
    });
  }

  if (marketInfo.faceValue) {
    listItem.push({
      value: getNumberValue(marketInfo.faceValue),
      key: 'faceValue',
    });
  }

  if (marketInfo.auditedPeRatioUsingBasicEps) {
    listItem.push({
      value: getNumberValue(marketInfo.auditedPeRatioUsingBasicEps),
      key: 'auditedPERatio',
    });
  }

  if (marketInfo.epsBasic) {
    listItem.push({
      value: getNumberValue(marketInfo.epsBasic),
      key: 'annualEPS',
    });
  }
  if (marketInfo.dividendYield) {
    listItem.push({
      value: getNumberValue(marketInfo.dividendYield),
      key: 'dividendYield',
    });
  }

  return listItem;
};

export const getDateRangeByYear = (year: number) => {
  return [moment().format('YYYY-MM-DD'), moment().subtract(2, 'year').format('YYYY-MM-DD')];
};

export const sortArrayByKey = <T>(array: Array<T>, key, type: 'ASC' | 'DEC') => {
  let sortArray;
  if (type === 'ASC') {
    sortArray = array.sort(function (a, b) {
      return a[key] - b[key];
    });
  } else {
    sortArray = array.sort(function (a, b) {
      return b[key] - a[key];
    });
  }

  return sortArray;
};

export const sortAsc = (data, key) => {
  const sort = data.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
  return sort;
};

export const getFilteredDataByKey = <T>(array: Array<T>, key, value) => {
  return array.filter((itm) => itm[key] === value);
};

export const renderDateTime = (date, format) => {
  return moment(date).format(format);
};

export const secureText = (text: string) => {
  if (text?.length) {
    const trimsEnd = text.substr(text.length - 4);

    return trimsEnd.padStart(trimsEnd?.length + (text.length - trimsEnd.length), '*');
  } else {
    return text;
  }
};
export const getStar = (count: number) => {
  return Array(count).fill('*').join('');
};
export const secureTextByLengthAndDirection = (text: string, length = 4, from: 'start' | 'end' = 'end') => {
  if (text?.length) {
    if (from === 'start') {
      const trimsStart = text.slice(length, text.length - length);
      return getStar(length).concat(trimsStart);
    } else {
      const trimsEnd = text.slice(0, text.length - length);
      return trimsEnd.concat(getStar(length));
    }
  } else {
    return text;
  }
};

export const secureTextWithStartSign = (startCount: number, text: string) => {
  const length = text.length;
  const parts = Math.ceil(length / startCount);
  let secureText = '';
  const starts = getStar(startCount);
  for (let i = 0; i < parts; i++) {
    if ((i + 1) % 2 === 0) {
      const start = i * 2;
      const end = start + startCount;
      const textSlice = text.slice(start, end);
      secureText = secureText + textSlice;
    } else {
      secureText = secureText + starts;
    }
  }

  return secureText;
};

export const getUserTimeZone = () => {
  return moment().format('Z');
};

export const checkImageValidation = (e) => {
  e?.fileList.forEach((file) => {
    file.status = 'success';
  });
  if (!e.file?.type?.includes('image')) {
    e.fileList = e.fileList?.filter((itm) => itm.uid !== e.file.uid);
    notification.error({
      message: 'Only Image files are accepted',
    });
  }
  return e;
};
export const getFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

export const filterAttachmentsAndFormData = (formData) => {
  const attachmentsObj = {};
  const _fData = {};
  Object.keys(formData).forEach((key) => {
    if (typeof formData[key] === 'string') {
      if (formData[key].includes('data:') && formData[key].length > 30) {
        attachmentsObj[key] = formData[key];
      } else {
        _fData[key] = formData[key];
      }
    } else {
      _fData[key] = formData[key];
    }
  });

  return { attachmentsObj, _fData };
};

export const isDayInSundayToThursday = (date) => {
  const dayValue = new Date(date).getDay();
  if (dayValue === 5 || dayValue === 6) {
    return false;
  } else {
    return true;
  }
};

export const isShowAlertTime = (currentTime) => {
  const time = moment(currentTime).utc(false).add(6, 'h').get('hour');

  const start = moment('04:00 PM', 'hh:mm A').get('hour');

  const end = moment('05:59 AM', 'hh:mm A').get('hour');

  if (start <= time) {
    return true;
  } else {
    if (end >= time) {
      return true;
    }
  }

  return false;
};

export const prepareTradingCode = (tradingCode: string) => {
  return encodeURI(tradingCode?.split('(')[0].trim());
};

export const getNumberKey = (number: number) => {
  switch (number) {
    case 1:
      return 'one';
    case 2:
      return 'two';
    case 3:
      return 'three';
    case 4:
      return 'four';
    case 5:
      return 'five';
    case 6:
      return 'six';

    default:
      return '';
  }
};

export const fileDownload = (fileUrl) => {
  FileSaver.saveAs(fileUrl, fileUrl.split('/')[fileUrl.split('/')?.length - 1]);
};

export const prepareRequestExpression = (exp: string) => {
  if (exp.includes('Tax')) {
    return exp.split('Tax')[1].trim();
  } else if (exp.includes('TCR')) {
    return exp.split('TCR')[1].trim();
  } else if (exp.includes('SR')) {
    return exp.split('SR')[1].trim();
  } else if (exp.includes('PR')) {
    return exp.split('PR')[1].trim();
  } else {
    return exp;
  }
};

export const getReturnValueByPercentage = (value: number, parentage: number) => {
  return (value * parentage) / 100;
};

export const isCalDayDisabled = (day, daysCount: number) => {
  // if the given day is before the current date or after the daysCount days then it is not within the range
  // So the day is disabled
  const next = moment().add(daysCount, 'd').format('YYYY-MM-DD');
  if (moment().isSame(day, 'd')) {
    return false;
  }

  const dayOfWeek = moment(day).day();
  if ([5, 6].includes(dayOfWeek)) {
    return true;
  }

  return moment(day).isBefore(moment()) || moment(day).isAfter(next);
};

export const calculateMarketPrice = (
  MKISTAT_PUB_LAST_TRADED_PRICE = 0,
  MKISTAT_SPOT_LAST_TRADED_PRICE = 0,
  MKISTAT_YDAY_CLOSE_PRICE = 0,
  type?: 'marketPrice' | ''
) => {
  if (Number(MKISTAT_PUB_LAST_TRADED_PRICE) === 0 && Number(MKISTAT_SPOT_LAST_TRADED_PRICE) === 0) {
    return type === 'marketPrice' ? 0 : Number(Number(MKISTAT_YDAY_CLOSE_PRICE).toFixed(2));
  } else {
    if (Number(MKISTAT_PUB_LAST_TRADED_PRICE) === 0) {
      return Number(Number(MKISTAT_SPOT_LAST_TRADED_PRICE).toFixed(2));
    }
  }
  return Number(Number(MKISTAT_PUB_LAST_TRADED_PRICE).toFixed(2));
};

export const calculateMarketPriceChange = (
  MKISTAT_PUB_LAST_TRADED_PRICE,
  MKISTAT_SPOT_LAST_TRADED_PRICE,
  MKISTAT_YDAY_CLOSE_PRICE,
  type?: 'marketPrice' | ''
) => {
  const marketPrice = calculateMarketPrice(
    MKISTAT_PUB_LAST_TRADED_PRICE,
    MKISTAT_SPOT_LAST_TRADED_PRICE,
    MKISTAT_YDAY_CLOSE_PRICE,
    type
  );
  return Number(marketPrice) - Number(MKISTAT_YDAY_CLOSE_PRICE);
};

export const calculatePriceChangePercentage = (
  MKISTAT_PUB_LAST_TRADED_PRICE,
  MKISTAT_SPOT_LAST_TRADED_PRICE,
  MKISTAT_YDAY_CLOSE_PRICE,
  type?: 'marketPrice' | ''
) => {
  const priceChange = calculateMarketPriceChange(
    MKISTAT_PUB_LAST_TRADED_PRICE,
    MKISTAT_SPOT_LAST_TRADED_PRICE,
    MKISTAT_YDAY_CLOSE_PRICE,
    type
  );
  return (Number(priceChange) / Number(MKISTAT_YDAY_CLOSE_PRICE)) * 100;
};

export const numberWithCommas = (x) => {
  // if (x) return (x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // console.log(typeof x);
  if (typeof x === 'number') {
    const roundNumber = Number(x.toFixed(2)).toFixed(2);
    return roundNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return x;
  }
};

export const numberWithCommasWithFloat = (x, float = 0) => {
  if (typeof x === 'number') {
    const roundNumber = Number(x.toFixed(float)).toFixed(float);
    return roundNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return x;
  }
};

export const randomLatter = () => {
  const letters = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];
  const letter = letters[Math.floor(Math.random() * letters.length)];
  return letter.toUpperCase();
};

export const numberToLetter = (number) => {
  const code = 'A'.charCodeAt(0);
  return String.fromCharCode(code + number);
};
export const prepareFileName = (fileName: string, fileExtension: string) => {
  //removing all white spaces from name
  fileName = fileName.replace(/\s/g, '');

  //adding uuid to filename
  fileName = `fileName_${uuidv4()}${fileExtension}`;

  return fileName;
};

export const isProd = () => {
  return process.env.NX_APP_ENV === 'prod';
};
export const isDev = () => {
  return process.env.NX_APP_ENV === 'dev';
};

export const removeWhiteSpaces = (str: string) => {
  return str.replace(/\s+/g, '');
};

export const removeSpecialChar = (str: string) => {
  return str.replace(/[^a-zA-Z ]/g, '');
};

export const replaceUnderscored = (string: string) => {
  return string.replace(/_/g, ' ');
};

export const camelToFlat = (camel) => {
  const camelCase = camel.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

  let flat = '';

  camelCase.forEach((word) => {
    flat = flat + word.charAt(0).toUpperCase() + word.slice(1) + ' ';
  });
  return flat;
};
export const encodeURI = (string?: string) => {
  if (string) {
    return encodeURIComponent(string);
  } else {
    return '';
  }
};

export const replaceZeroToAndPercentage = (string: string) => {
  return string.replace(/00000/g, '&');
};
export const isTrackHolderVirtual = (trackHolderId = 0) => {
  if (Number(trackHolderId) === 9999 || Number(trackHolderId) === 8888) {
    return true;
  } else {
    return false;
  }
};

export const isTrackHolderVirtualSimulation = (trackHolderId = 0) => {
  if (Number(trackHolderId) === 9999) {
    return true;
  } else {
    return false;
  }
};
export const isTrackHolderVirtualBO = (trackHolderId = 0) => {
  if (Number(trackHolderId) === 8888) {
    return true;
  } else {
    return false;
  }
};

export const isDayIsHoliDay = (holidays, date) => {
  let isHoliday = false;
  const currentDate = formateDate(date, DATE_FORMATS.DATE);
  holidays?.forEach((itm) => {
    const date = formateDate(itm.date, DATE_FORMATS.DATE);
    if (moment(date, DATE_FORMATS.DATE).isSame(currentDate)) {
      isHoliday = true;
    } else {
      isHoliday = false;
    }
  });
  return isHoliday;
};

export const differenceBetweenTowTimes = (day1: Moment, day2: string) => {
  const duration = moment.duration(day1.diff(day2));
  return duration.asDays();
};

export const checkHoliday = (holidays: string[], checkDate: string) => {
  let isHoliday = false;
  const currentDate = moment(checkDate).format(DATE_FORMATS.DATE);

  holidays?.forEach((date) => {
    const _date = moment(date).format(DATE_FORMATS.DATE);
    if (moment(_date, DATE_FORMATS.DATE).isSame(currentDate)) {
      isHoliday = true;
    }
  });
  return isHoliday;
};

export const getDateDifference = (date: string, holidays: string[]) => {
  const currentDate = moment().format(DATE_FORMATS.DATE);
  let shouldRun = true;
  let dateCount = 0;
  let tempDate = date;

  while (shouldRun) {
    const isHoliday = isDayIsHoliDay(
      holidays?.map((itm) => {
        return {
          date: itm,
        };
      }),
      tempDate
    );
    const isWeekend = isDateIsWeekend(tempDate);

    if (isHoliday === false && isWeekend === false) {
      dateCount = dateCount + 1;
    }
    if (moment(tempDate, DATE_FORMATS.DATE).isSame(currentDate)) {
      shouldRun = false;
    }
    tempDate = moment(moment(tempDate, DATE_FORMATS.DATE).add(1, 'day')).format(DATE_FORMATS.DATE);
  }

  return dateCount;
};

export const getNextTradeDay = (nextDate: string, holidays: any[]) => {
  let shouldRun = true;
  let dateFound: string | undefined = undefined;

  let tempDate = nextDate;
  while (shouldRun) {
    const isHoliday = checkHoliday(
      holidays.map((itm) => itm.date),
      tempDate
    );

    const isWeekend = isDateIsWeekend(tempDate);

    if (isHoliday === false && isWeekend === false) {
      dateFound = tempDate;
    }
    if (dateFound) {
      shouldRun = false;
    }
    tempDate = moment(moment(tempDate, DATE_FORMATS.DATE).add(1, 'day')).format(DATE_FORMATS.DATE);
  }
  return dateFound;
};

export const prepareNumberValue = (number?: string | number) => {
  if (number) {
    return Number(Number(number).toFixed(2));
  }

  return Number(number);
};

export const generateCronExpressionFormDate = (date) => {
  const month = moment(date).get('M') + 1;
  const day = moment(date).get('D');

  return `21 12 ${day} ${month} *`;
};

// export const getTradingHour = () => {
//   return [
//     moment(`${moment().format(DATE_FORMATS.DATE)} 10:00 am`).format(`YYYY-MM-DD HH:mm a`),
//     moment(`${moment().format(DATE_FORMATS.DATE)} 02:30 pm`).format(`YYYY-MM-DD HH:mm a`),
//   ];
// };

// export const isDateTimeInTradingHour = (dateTime: string) => {
//   const [start, end] = getTradingHour();
//   const isBetween = moment(dateTime).isBetween(moment(start), moment(end));

//   return isBetween;
// };
export const getTradingHour = () => {
  const currentDate = moment().format(DATE_FORMATS.DATE);
  return [
    moment(`${currentDate} 10:00 am`, DATE_FORMATS.CUSTOMER_READABLE),
    moment(`${currentDate} 02:30 pm`, DATE_FORMATS.CUSTOMER_READABLE),
  ];
};

export const isTradingHour = (dateTime: string) => {
  const [start, end] = getTradingHour();
  const isBetween = moment(dateTime, DATE_FORMATS.CUSTOMER_READABLE).isBetween(start, end);

  return isBetween;
};

export const isAfterTradingHour = () => {
  const currentDate = moment().format(DATE_FORMATS.DATE);
  const checkedDateTime = moment().add(6, 'hour').format(DATE_FORMATS.CUSTOMER_READABLE);

  const [start, end] = [
    moment(`${currentDate} 02:30 pm`, DATE_FORMATS.CUSTOMER_READABLE),
    moment(`${currentDate} 11:59 pm`, DATE_FORMATS.CUSTOMER_READABLE),
  ];

  const isBetween = moment(checkedDateTime, DATE_FORMATS.CUSTOMER_READABLE).isBetween(start, end);

  return isBetween;
};

export const validateEmail = (email) => {
  // Regular expression pattern for validating email addresses
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the pattern
  return pattern.test(email);
};

export const calculateAge = (dob) => {
  const age = moment().diff(dob, 'years');
  return age;
};

// Convert Nummber to Ordial (1 -> 1st, 2 -> 2nd)
export const numberToOrdinal = (n: number) => {
  const numToOrdinalMap = {
    1: '1st',
    2: '2nd',
    3: '3rd',
    4: '4th',
    5: '5th',
  };
  try {
    return numToOrdinalMap[n] || n;
  } catch (e) {
    return n;
  }
};

// Convert string from 'Snake Case' to 'snake_case'
export function toLowerSnakeCase(s: string) {
  if (!s || typeof s !== 'string') {
    return s;
  }
  return s?.toLowerCase()?.split(' ')?.join('_');
}

// Convert seconds to HH:MM:SS format
export const secondsToHHMMSS = (seconds = 0) => {
  const duration = moment.duration(seconds, 'seconds');
  return moment.utc(duration.asMilliseconds()).format('HH:mm:ss') ?? '';
};
